import type { PokerTableStyleId } from "../types";

export type PokerTableStyle = {
  id: PokerTableStyleId;
  label: string;
  description: string;
  felt: string;
  feltHighlight: string;
  wood: string;
  woodHighlight: string;
  rail: string;
  metal: string;
  accent: string;
  neon?: string;
  background: string;
  light: string;
  exposure: number;
};

export const POKER_TABLE_STYLES: readonly PokerTableStyle[] = [
  { id: "casino-emerald", label: "Casino Emerald", description: "Forest speed cloth, espresso walnut and black leather", felt: "#06472f", feltHighlight: "#559678", wood: "#32190d", woodHighlight: "#8a4f27", rail: "#0b0b0b", metal: "#b59b61", accent: "#d5bd7c", background: "#020b08", light: "#ffe5b5", exposure: 1.06 },
  { id: "midnight-walnut", label: "Midnight Walnut", description: "Navy cloth, hand-rubbed walnut and saddle leather", felt: "#102e48", feltHighlight: "#668aa2", wood: "#4a2412", woodHighlight: "#aa6737", rail: "#24130d", metal: "#c3a063", accent: "#ddb974", background: "#05080d", light: "#ffd7a0", exposure: 1.1 },
  { id: "crimson-club", label: "Crimson Club", description: "Burgundy cloth, oxblood leather and black lacquer", felt: "#65192a", feltHighlight: "#c16a73", wood: "#16080a", woodHighlight: "#5c2025", rail: "#26090e", metal: "#c59a4b", accent: "#e0b65c", background: "#0b0305", light: "#ffd1a0", exposure: 1.08 },
  { id: "arctic-neon", label: "Arctic Neon", description: "Graphite cloth with a recessed cyan light ring", felt: "#152d35", feltHighlight: "#5b8790", wood: "#0b1014", woodHighlight: "#34434b", rail: "#070a0d", metal: "#9bb3ba", accent: "#79efff", neon: "#26dfff", background: "#02070a", light: "#b9efff", exposure: 1.14 },
  { id: "royal-violet", label: "Royal Violet", description: "Plum speed cloth and a magenta-violet under-rail glow", felt: "#3b205d", feltHighlight: "#8e6bb0", wood: "#140d1b", woodHighlight: "#483058", rail: "#09070c", metal: "#c2a6ce", accent: "#e5a8ff", neon: "#c43cff", background: "#08030e", light: "#e8c5ff", exposure: 1.13 },
  { id: "jade-neon", label: "Jade Neon", description: "Deep jade cloth, ebony raceway and emerald light", felt: "#073f38", feltHighlight: "#4c968a", wood: "#071310", woodHighlight: "#234f43", rail: "#050a09", metal: "#8bb9aa", accent: "#75f2c6", neon: "#20e6a1", background: "#010907", light: "#b9ffe7", exposure: 1.12 },
] as const;

export const DEFAULT_POKER_TABLE_STYLE: PokerTableStyleId = "casino-emerald";

export function pokerTableStyle(id?: PokerTableStyleId) {
  return POKER_TABLE_STYLES.find((style) => style.id === id) ?? POKER_TABLE_STYLES[0];
}
